import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const isLoaded = useSelector((state) => state.auth.isLoaded);

  useEffect(() => {
    if (isLoaded && !isLoggedIn) {
      navigate('/login', { replace: true, state: { from: location.pathname } });
    }
  }, [isLoaded, isLoggedIn, navigate]);

  return children;
};

export default AuthGuard;
